























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'Modal'
})
export default class Modal extends Vue {
    @Prop({type: [String], required: true})
    private headerText!: string;
    @Prop({type: [String], required: false})
    private bodyText?: string;
    @Prop({type: [String], required: false})
    private cancelButtonText?: string;
    @Prop({type: [String], required: false, default: ''})
    private successButtonText!: string;
    @Prop({type: [Boolean], required: false, default: false})
    private disableSuccess!: boolean;
    @Prop({type: [String], required: false, default: 'max-content' })
    private maxWidth!: string;
    @Prop({type: [Boolean], required: false, default: true })
    private showButtons!: boolean;
    @Prop({ type: [Boolean], required: false, default: true})
    private allowClose!: boolean;

    private dynamicModalContainer = { 'max-width': '' };

    public created() {
        this.dynamicModalContainer['max-width'] = this.maxWidth + 'px';
    }

    cancel(event: any) {
        if (event.target.className.indexOf('cancel-on-click') !== -1) {
            this.$emit('cancel-event');
        }
    }
}
